<script>
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import Select from "../../components/Select.svelte";
	import CheckboxButton from "../../components/CheckboxButton.svelte";

	export let missedEventType = null;
	export let missedEvent;
	export let howOften = null;
	export let disabled = null;
	export let required = null;

	const howOftenOptions = [
		{ label: "Always", value: "Always" },
		{ label: "Sometimes", value: "Sometimes" },
		{ label: "Every now and again", value: "Every now and again" }
	];
</script>

<FormRow>
	<FormColumn>
		<CheckboxButton
			{disabled}
			id={missedEventType.replace(" ", "_")}
			label={missedEventType}
			bind:checked={missedEvent} />
	</FormColumn>
</FormRow>

{#if missedEvent}
	<FormRow>
		<FormColumn>
			<Select
				{disabled}
				{required}
				label="How often would this happen?"
				id="{missedEventType.replace(' ', '_')}_hours"
				bind:value={howOften}
				optionList={howOftenOptions}
				textProperty="label"
				valueProperty="value" />
		</FormColumn>
	</FormRow>
{/if}
